import React, { Component, useReducer } from 'react';
import {Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'
import { FaPaperPlane} from 'react-icons/fa'
import Participant from './participant';
import {MdCallEnd} from 'react-icons/md'
import {FcEndCall} from 'react-icons/fc'

class Room extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);

      this.state = {
        remoteParticipants: Array.from(this.props.room.participants.values()),
        respiration_rate: null,
        oxygen_saturation: null,
        systolic_blood_pressure: null,
        pulse_rate: null,
        temperature: null,
        steps: null,
        sleep: null,
        weight: null,
        blood_sugar: null,
        selected_index: 0,
        current_client_metrics: null
      }
    
      this.leaveRoom = this.leaveRoom.bind(this);

      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.ViewClient = (selected_index) => {
        this.setState({selected_index: selected_index})
      }

      this.GetGoogleFitData = () => {
        const {cookies} = this.props
        var redirect_uri = 'https://onfit.netlify.app'
        var google_fit_client_id = '886472897374-s2u7n72g933iicbg45q2ofp22ptvc4fv.apps.googleusercontent.com'
        var google_fit_client_secret = 'qzq_z79ToXRnck0J4HzgOjSQ'
        var auth_prompt_uri = 'https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=https%3A%2F%2F'+redirect_uri+'&prompt=consent&response_type=code&client_id='+google_fit_client_id+'&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.activity.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.blood_glucose.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.blood_pressure.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.body.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.body_temperature.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.heart_rate.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.location.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.nutrition.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.oxygen_saturation.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.reproductive_health.read+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Ffitness.sleep.read&access_type=offline'
        
        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))

        axios.post(Backend_Url + auth_prompt_uri, data)
        .then((res) => {
            let result = res.data
            console.log('Metrics fetched.')
        }).catch((error) => {
            console.log('Something went wrong while to fetch metrics.')
        })

        this.SendMetricsToServer()
      }

      this.SendMetricsToServer = () => {
        const {cookies} = this.props
        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('respiration_rate', this.state.respiration_rate)
        data.append('oxygen_saturation', this.state.oxygen_saturation)
        data.append('systolic_blood_pressure', this.state.systolic_blood_pressure)
        data.append('pulse_rate', this.state.pulse_rate)
        data.append('temperature', this.state.temperature)
        data.append('steps', this.state.steps)
        data.append('sleep', this.state.sleep)
        data.append('weight', this.state.weight)
        data.append('blood_sugar', this.state.blood_sugar)

        axios.post(Backend_Url + 'saveGoogleFitMetrics', data)
        .then((res) => {
            let result = res.data
            console.log('Metrics saved.')
        }).catch((error) => {
            console.log('Something went wrong while to save metrics.')
        })
      }

      this.GetClientMetrics = (user_id) => {
        const { cookies } = this.props;
        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('user_id', user_id)

        axios.post(Backend_Url + 'getUserGoogleFitMetrics', data)
        .then((res) => {
            let result = res.data
              this.setState({current_client_metrics: result})
        }).catch((error) => {
            console.log(error)
        })
      }

      this.ClientMetrics = () => {
        var request_by_session_author = this.props.request_by_session_author
        if(request_by_session_author == true){
          var current_client_metrics = this.state.current_client_metrics
          return<div>

          </div>
        }else{
          return<div style={{display: 'none'}}></div>
        }
      }

      this.EndSession = () => {
        const {cookies} = this.props
        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('live_id', this.props.session_id)

        axios.post(Backend_Url + 'stopLive', data)
        .then((res) => {
            let result = res.data
            alert('Session ended.')
            this.props.room.disconnect();
            let port = (window.location.port ? ':' + window.location.port : '')
            window.location.href = '//' + window.location.hostname + port + '/dashboard'
            this.leaveRoom()
        }).catch((error) => {
            alert('Something went wrong, please try again.')
        })
      }

      this.EndSessionButton = (e) => {
        var request_by_session_author = this.props.request_by_session_author
        if(request_by_session_author == true){
          return<Button onClick={this.EndSession} style={{zIndex: 1, fontSize: '10px', top: '10px', left: '280px', position: 'absolute', width: '90px', height: '90px', borderRadius: '50%'}}>
            <FcEndCall size='25px'/>
            <br/>
            End Session
          </Button>
        }else{
          return<div>

          </div>
        }
      }
    }

    componentDidMount() {
        // Add event listeners for future remote participants coming or going
        this.props.room.on('participantConnected', participant => this.addParticipant(participant));
        this.props.room.on('participantDisconnected', participant => this.removeParticipant(participant));
        
        window.addEventListener("beforeunload", this.leaveRoom);
        // this.GetGoogleFitData()
        // this.interval = setInterval(() => this.GetGoogleFitData(), 1000)
    }

    componentWillUnmount() {
        this.leaveRoom();
    }

    addParticipant(participant) {
        console.log(`${participant.identity} has joined the room.`);
        
        this.setState({
          remoteParticipants: [...this.state.remoteParticipants, participant]
        });
    }
    
    removeParticipant(participant) {
        console.log(`${participant.identity} has left the room`);
    
        this.setState({
          remoteParticipants: this.state.remoteParticipants.filter(p => p.identity !== participant.identity)
        });
    }

    leaveRoom() {
        this.props.room.disconnect();
        this.props.returnToLobby();
    }

    render() {
      var selected_index = this.state.selected_index
      return (
        <div style={{height: '100vh', backgroundColor: 'black', position: 'relative'}}>
          <div style={{width: '100%', height: '100vh', overflowY: 'hidden', overflowX: 'hidden', position: 'absolute', zIndex: 1}}>
            { 
                  this.state.remoteParticipants.length === 0
                  ? <div>
                    
                  </div>
                  : <Participant window='main' key={this.state.remoteParticipants[selected_index].identity} participant={this.state.remoteParticipants[selected_index]}/>
              }
          </div>
          <Button id="leaveRoom" onClick={this.leaveRoom} style={{zIndex: 1, fontSize: '10px', top: '10px', left: '180px', position: 'absolute', width: '90px', height: '90px', borderRadius: '50%'}}>
            <MdCallEnd size='15px'/>
            <br/>
            Leave Session
          </Button>
          {' '}
          <this.EndSessionButton/>
          <div class='sub_streams'>
            <Participant window='vid_map' window='sub' key={this.props.room.localParticipant.identity} localParticipant="true" participant={this.props.room.localParticipant}/>
            {
              this.state.remoteParticipants.map((participant, index) => 
                <div onClick={() => this.ViewClient(index)}>
                  <Participant class='vid_map' window='sub' key={participant.identity} participant={participant}/>
                </div>
              )
            }
          </div>
          <br/>
        </div>
      );
    }

  };
  
  export default withCookies(Room);